import { render, staticRenderFns } from "./AccountApprovalTable.vue?vue&type=template&id=2dcb0d62&scoped=true"
import script from "./AccountApprovalTable.vue?vue&type=script&lang=js"
export * from "./AccountApprovalTable.vue?vue&type=script&lang=js"
import style0 from "./AccountApprovalTable.vue?vue&type=style&index=0&id=2dcb0d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb0d62",
  null
  
)

export default component.exports